'use client';

import Link from 'next/link';
import addEventToDataLayer from 'components/Integration/addEventToDataLayer';
import { SEARCH_RESULT_COMPONENT } from 'components/Integration/constantsLabel';
import IngressinhoImg from 'assets/logos/ingressinho.svg';

import * as styles from '../SearchSpecificTerms.css';

function SearchToAccessHelperCenter({ term, link }: { term: string; link: string }) {
  return (
    <div className={`${styles.SearchSpecificTermsContainer} ${styles.SearchSpecificTermsContainerCenter}`}>
      <IngressinhoImg className={styles.SearchSpecificTermsImg} />
      <div>
        <span className={styles.SearchSpecificTermsText}>{`Buscando por ${term}? `}</span>
        <Link
          className={styles.SearchSpecificTermsLink}
          href={link}
          aria-label={`Acesse nossa central de ajuda para informações sobre ${term}`}
          onClick={() => {
            addEventToDataLayer({
              category: 'discoveryInteraction',
              label: `${SEARCH_RESULT_COMPONENT}${term.charAt(0).toUpperCase()}${term.substring(1)}`,
              action: 'click',
            });
          }}
        >
          Acesse nossa central de ajuda!
        </Link>
      </div>
    </div>
  );
}

export default SearchToAccessHelperCenter;
